import './index.css'
import { TenantPage } from './pages/tenant/TenantPage'
import { Routes, Route } from 'react-router-dom'
import { useEffect } from 'react'
import { useInterval } from './hooks/useInterval'
import { sessionFreshen } from './api/session/sessionFreshen'
import { useApi } from './hooks/useApi'
import { AdminPage } from './pages/admin/AdminPage'
import { KbArticleEdit } from './pages/admin/kb/article/KbArticleEdit'
import { Icons } from './pages/admin/misc/Icons'
import { KbArticleList } from './pages/admin/kb/article/KbArticleList'
import { UserList } from './pages/admin/user/UserList'
import { UserEditPage } from './pages/admin/user/UserEditPage'
import { WebHitList } from './pages/admin/webHits/WebHitList'
import { LogInPage } from './pages/user/LogInPage'
import { LogOutPage } from './pages/user/LogOutPage'
import { GoogleAuthVerifyPage } from './pages/user/GoogleAuthVerifyPage'
import { routes } from './utilities/routes'
import { HomeLaunchPage } from './pages/HomeLaunchPage'
import { TenantEditPage } from './pages/tenant/edit/TenantEditPage'
import { TenantBillingInvoiceListPage } from './pages/tenant/billing/TenantBillingInvoiceListPage'
import { FeedViewPage } from './pages/tenant/feed/FeedViewPage'
import { FeedEditPage } from './pages/tenant/feed/FeedEditPage'
import { useTenantId } from './hooks/useTenantId'

export function App() {

  const tid = ':tenant'
  const tenantId = useTenantId()
  const api = useApi()

  //--------------------------------------------------------------------------------
  // On mount and whenever the tenant ID changes
  useEffect(
    () => void sessionFreshen(api, tenantId),
    [tenantId]
  )

  //--------------------------------------------------------------------------------
  useInterval(
    () => sessionFreshen(api, tenantId),
    api.status.session?.loggedIn
      ? 5 * 60 * 1000
      : 0
  )  // Keep the session active

  //--------------------------------------------------------------------------------
  // Render
  return (
    <div className="app">
      <Routes>

        {/* ------------------------------------------------------------ */}
        {/* Third party authentication */}

        <Route path={routes.googleAuthVerify()} element={<GoogleAuthVerifyPage />} />

        {/* ------------------------------------------------------------ */}
        {/* Getting started */}

        <Route path='/' element={<HomeLaunchPage />} />
        <Route path={routes.logIn()} element={<LogInPage />} />
        <Route path={routes.logOut()} element={<LogOutPage />} />

        {/* ------------------------------------------------------------ */}
        {/* Tenant pages */}

        <Route path={routes.logIn(tid)} element={<LogInPage />} />
        <Route path={routes.logOut(tid)} element={<LogOutPage />} />
        <Route path={routes.home(tid)} element={<TenantPage />} />

        <Route path={routes.tenantEdit(tid)} element={<TenantEditPage />} />

        <Route path={routes.tenantInvoices(tid)} element={<TenantBillingInvoiceListPage />} />

        <Route path={routes.feedView(tid, ':feed')} element={<FeedViewPage />} />
        <Route path={routes.feedEdit(tid, ':feed')} element={<FeedEditPage />} />

        {/* ------------------------------------------------------------ */}
        {/* Getting started */}

        <Route path={routes.admin()} element={<AdminPage />} />

        <Route path={routes.adminKbArticleEdit(':id')} element={<KbArticleEdit />} />
        <Route path={routes.adminKbArticles()} element={<KbArticleList />} />

        <Route path={routes.adminUsers()} element={<UserList />} />
        <Route path={routes.adminUserEdit(':id')} element={<UserEditPage />} />
        <Route path={routes.adminWebHits()} element={<WebHitList />} />
        <Route path={routes.adminIcons()} element={<Icons />} />

        {/* ------------------------------------------------------------ */}
        {/* Anything else */}

        <Route path='*' element={<>404 - Not found</>} />
      </Routes>
    </div>
  )
}

export default App
